import { ElMessage } from 'element-plus'

class ShowMessage {
  //提示默认配置项
  defaltOption:any = {
    dangerouslyUseHTMLString: true,
    message: "",
    duration:2000 ,
    showClose: false,
    offset: 100,
    customClass: "",
    onClose: () => {}
  };

  //
  messageIsString = false;
  messageType = ""; // info  消息，error：错误, success：成功
  iconName = "" as string | undefined; // 图标名称，默认不显示

  /**
   * 构造函数
   * @param {*} type 提示类型 info 消息，error：错误 , success：成功
   * @param {*} options 选项 string时表示内容，object 时表示选项
   * @param {*} single 是否禁多次提示
   */
  ShowMessage(type:string, single:boolean) {
    (ElMessage as any)[type](this.defaltOption);
    if(!this.messageIsString){
      this.defaltOption = {
        dangerouslyUseHTMLString: true,
        message: "",
        duration:3000 ,
        showClose: false,
        offset: 20
      }
    }
  }

  /**
   * 内容提示
   * @param {*} options 选项
   * @param {*} single 是否禁止多次提示
   */
  info(options:any, single = true) {
    this.messageType = "info";
    this.allocationMethod(options);
    this.defaltOption.customClass = "custom-message";
    this.ShowMessage("info", single);
  }

  /**
   * 错误提示
   * @param {*} options 选项
   * @param {*} single 是否禁止多次提示
   */
  error(options:any, single = true) {
    this.setMessage(options, false ,"error", "custom-message",single);
  }

  /**
   * 成功提示
   * @param {*} options 选项
   * @param {*} single 是否禁止多次提示
   */
  success(options:any, single = true) {
    this.setMessage(options, false ,"success", "custom-message",single);
  }

  warning(options:any, icon = "", single = true) {
    this.setMessage(options, true ,"warning", "custom-warning",single, icon);
  }

  //红色告警
  redAlert(options:any, icon = "", single = true) {
    this.setMessage(options, true ,"warning", "custom-warning red-warning",single, icon);
  }

  //黄色告警
  yellowAlert(options:any, icon = "", single = true) {
    this.setMessage(options, true ,"warning", "custom-warning yellow-warning",single, icon);
  }

  setMessage(options:any, isHasIcon:false | true, type:"warning" | "error" | "success", className:string, single:true | false, icon?:string) {
    this.messageType = type;
    if(isHasIcon){
      this.iconName = icon;
    }
    this.allocationMethod(options);
    this.defaltOption.customClass = className;
    this.ShowMessage(type, single);
  }

 

  /**
   * 分配方法
   * @param {*} argOption
   */
  allocationMethod(argOption:string | object) {
    if (typeof argOption === "string") {
      this.messageIsString = true;
      this.setUpContent(argOption);
    } else {
      this.messageIsString = false;
      this.setUpOption(argOption);
    }
  }

  /**
   * 设置提示内容
   * @param {*} msg 内容
   */
  setUpContent(msg:string) {
    let icon = null
    if(this.messageType == "info"){
        icon = require("@/assets/images/infoIcon.png")
    }else if(this.messageType == "success"){
        icon = require("@/assets/images/successIcom.png")
    }else if(this.messageType == "error"){
        icon = require("@/assets/images/errorIcon.png");
    }else if (this.messageType == "warning" && this.iconName) {
      icon = require(`@/assets/images/${this.iconName}.png`);
    }
    if(this.messageType == "warning"){
      this.defaltOption.message = `
        <div class="waring-content">
          ${this.iconName?`<img src="${icon}" alt="">`:""}          
          <p class="message-text">${msg}</p>
        </div>
      `;
      return;
    }
    this.defaltOption.message = `
        <div class="myMessageContent">
            <img src="${icon}" alt="">
            <p class="message-text">${msg}</p>
        </div>
    `;
  }

  /**
   * 设置提示选项
   * @param {*} optionObject 调用提示组件时传递的选项
   */
  setUpOption(optionObject:any) {
    Object.keys(this.defaltOption).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(optionObject, key)) {
        this.defaltOption[key] = optionObject[key];
      }

      if (key == "message") {
        this.setUpContent(optionObject[key]);
      }
    });
  }

  /**
   * 手动关闭
   */
  close(){
    ElMessage.closeAll();
  }
}
export default new ShowMessage();
